import React from 'react';
import { ImpContainer, ImpCard, ImpPad } from '../..';
import styled from 'styled-components';
const CardContainer = styled(ImpContainer) `
  transition: 0.1s;

  :hover {
    filter: brightness(0.85);
  }

  :active {
    filter: brightness(0.75);
  }
`;
export default function ImpCardThumbnail({ src, id, onClick, isSelected, }) {
    const outlineColor = isSelected ? 'var(--merchant-color)' : 'transparent';
    return (React.createElement(ImpContainer, { border: `1px solid ${outlineColor}`, dataTestId: "card-thumbnail-container", width: "fit-content", borderRadius: "8px" },
        React.createElement(ImpPad, { padding: "4px" },
            React.createElement(CardContainer, null,
                React.createElement(ImpCard, { dataTestId: "thumbnail-card", src: src, widthPx: 108, heightPx: 69, borderRadiusPx: 4, handleClick: onClick, id: id })))));
}
//# sourceMappingURL=ImpCardThumbnail.js.map